import React, { useState } from 'react';
import { 
  Users, 
  ShieldCheck, 
  Send, 
  CheckCircle2, 
  Lock,
  Info
} from 'lucide-react';

export const FamilyConsentPage: React.FC = () => {
  const [memberEmail, setMemberEmail] = useState('');
  const [relationship, setRelationship] = useState('Partner');
  const [sent, setSent] = useState(false);

  const handleSend = (e: React.FormEvent) => {
    e.preventDefault();
    if (memberEmail.trim()) {
      setSent(true);
    }
  };

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-8">
      <div className="text-center space-y-2">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-950 text-emerald-300 text-xs font-bold border border-emerald-800">
          <Users className="w-3.5 h-3.5" />
          <span>AUSTRALIAN PRIVACY PRINCIPLE 6 CONSENT FRAMEWORK</span>
        </div>
        <h1 className="text-3xl font-extrabold text-white">Family Privacy & Consent Authorization</h1>
        <p className="text-xs text-slate-400 max-w-lg mx-auto">
          Under the Privacy Act 1988, adult family members must grant explicit digital consent before their personal identifiers can be monitored.
        </p>
      </div>

      <div className="bg-slate-900 border border-slate-800 rounded-3xl p-6 sm:p-8 space-y-6 shadow-xl text-xs">
        {sent ? (
          <div className="p-6 rounded-2xl bg-emerald-950/60 border border-emerald-800 text-center space-y-2">
            <CheckCircle2 className="w-10 h-10 text-emerald-400 mx-auto" />
            <h3 className="font-bold text-white text-sm">Consent Invitation Dispatched</h3>
            <p className="text-slate-300">We sent an encrypted authorization link to <span className="font-mono text-emerald-300">{memberEmail}</span>.</p>
          </div>
        ) : (
          <form onSubmit={handleSend} className="space-y-4">
            <div>
              <label className="block font-bold text-slate-300 mb-1">Family Member Email:</label>
              <input
                type="email"
                value={memberEmail}
                onChange={(e) => setMemberEmail(e.target.value)}
                placeholder="e.g. sarah.mitchell@example.com.au"
                required
                className="w-full px-3.5 py-2.5 rounded-xl bg-slate-950 border border-slate-700 text-white focus:outline-none focus:border-emerald-500"
              />
            </div>

            <div>
              <label className="block font-bold text-slate-300 mb-1">Relationship:</label>
              <select
                value={relationship}
                onChange={(e) => setRelationship(e.target.value)}
                className="w-full px-3.5 py-2.5 rounded-xl bg-slate-950 border border-slate-700 text-white"
              >
                <option value="Partner">Partner / Spouse</option>
                <option value="Parent">Elderly Parent</option>
                <option value="Adult Child">Adult Child (Over 18)</option>
              </select>
            </div>

            <button
              type="submit"
              className="w-full py-3 bg-emerald-600 hover:bg-emerald-500 text-white rounded-xl font-bold shadow-lg transition-colors"
            >
              Send Consent Authorization Request
            </button>
          </form>
        )}
      </div>
    </div>
  );
};
